import Button from '@datacamp/waffles-button';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Reconnector = _ref => {
  let {
    debugMessage,
    multiplexerStatusMessage,
    restartSession
  } = _ref;
  const {
    t
  } = useTranslation('translation', {
    keyPrefix: 'ExplorableExercise'
  });
  const getCustomFeedback = React.useCallback(() => {
    switch (multiplexerStatusMessage) {
      case 'dockerFailedToRun':
        return t('Reconnector.dockerFailedToRunMessage');
      case 'expired':
        return t('Reconnector.expiredMessage');
      case 'dockerCrashed':
        return t('Reconnector.dockerCrashedMessage');
      case 'initCodeTimedOut':
        return t('Reconnector.initCodeTimedOutMessage');
      default:
        return t('Reconnector.defaultFeedbackMessage');
    }
  }, [multiplexerStatusMessage, t]);
  return ___EmotionJSX("div", {
    className: "dc-u-fx dc-u-fx-fww dc-u-fx-aic dc-u-bgc-grey-100 dc-u-fx-jcc dc-u-wh-100pc dc-u-ta-center dc-u-of-scroll dc-u-p-24"
  }, ___EmotionJSX("div", null, ___EmotionJSX("div", null, ___EmotionJSX("h3", null, getCustomFeedback()), ___EmotionJSX("p", null, t('Reconnector.text'))), ___EmotionJSX(Button, {
    appearance: "primary",
    dataAttributes: {
      cy: 'restart-session-button'
    },
    intent: "success",
    onClick: restartSession,
    size: "small"
  }, t('Reconnector.button'))), debugMessage !== undefined && ___EmotionJSX("div", null, ___EmotionJSX("h4", null, t('Reconnector.debugMessageTitle')), ___EmotionJSX("p", {
    className: "dc-u-color-red dc-u-ta-left dc-u-ws-pre-wrap",
    style: {
      wordBreak: 'break-word'
    }
  }, debugMessage)));
};
export default Reconnector;